import type { JSX, Ref } from 'react'

import { TimeLineDivider } from 'atoms/Divider/Templates'
import { TextBoxMaxLine1Footnote5Secondary } from 'atoms/TextBox/Templates'
import { TimeLineSectionSC, TimeLineSectionWrapper } from '../TimeLine.styled'

export interface ITimeLineSection {
  ref?: Ref<HTMLDivElement>
  title: string
}

export function TimeLineSection({ title, ref }: ITimeLineSection): JSX.Element {
  return (
    <TimeLineSectionSC ref={ref}>
      <TimeLineSectionWrapper>
        <TimeLineDivider />
        <TextBoxMaxLine1Footnote5Secondary title={title} />
      </TimeLineSectionWrapper>
    </TimeLineSectionSC>
  )
}
